export const calculateAPRMonthlyPayment = (totalCost, rate, financePlan) => {
  let monthlyRate = rate / 12;
  let monthlyPayment = totalCost * monthlyRate / (1 - Math.pow(1 + monthlyRate, - financePlan));
  return monthlyPayment;
}